import { styled } from '@linaria/react';
import { Button } from '../Button';
export const COMPACT_HEADER_TOP_HEIGHT = 61;
type HeaderElementProps = {
  isCompact?: boolean;
};
export const HeaderElement = /*#__PURE__*/styled('header')({
  name: "HeaderElement",
  class: "h1vcsh91",
  propsAsIs: false
});
const _exp3 = /*#__PURE__*/() => ({
  isCompact
}) => isCompact ? 61 - 1 : 80;
export const HeaderTopContent = /*#__PURE__*/styled('div')({
  name: "HeaderTopContent",
  class: "h17q355d",
  propsAsIs: false,
  vars: {
    "h17q355d-0": [_exp3(), "px"]
  }
});
export const HeaderBottomContent = /*#__PURE__*/styled('div')({
  name: "HeaderBottomContent",
  class: "h17yginw",
  propsAsIs: false
});
export const CenterComponentWrapper = /*#__PURE__*/styled('div')({
  name: "CenterComponentWrapper",
  class: "c104yh69",
  propsAsIs: false
});
export const RightComponentWrapper = /*#__PURE__*/styled('div')({
  name: "RightComponentWrapper",
  class: "rm914gl",
  propsAsIs: false
});
export const LogoWrapper = /*#__PURE__*/styled('div')({
  name: "LogoWrapper",
  class: "ltpxmn8",
  propsAsIs: false
});
export const StyledLogo = /*#__PURE__*/styled('a')({
  name: "StyledLogo",
  class: "s1cs6e5g",
  propsAsIs: false
});
const _exp10 = /*#__PURE__*/() => Button;
export const BackButton = /*#__PURE__*/styled(_exp10())({
  name: "BackButton",
  class: "b5kcyk1",
  propsAsIs: true
});

require("./styles.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.ts");